export function isObjKey<T extends object>(
  key: PropertyKey,
  obj: T
): key is keyof T {
  return key in obj;
}

export function isNumber(value?: string | number): boolean {
  return value != null && value !== "" && !isNaN(Number(value.toString()));
}

type Entries<T> = {
  [K in keyof T]: [K, T[K]];
}[keyof T][];

export function typedObjectKeys<T extends object>(object: T): (keyof T)[] {
  return Object.keys(object) as (keyof T)[];
}

export function typedObjectEntries<T extends object>(object: T): Entries<T> {
  return Object.entries(object) as Entries<T>;
}
